import { IDataTh, ThCoreIndex } from "src/Pages/components";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";


export const THeadBordero = () => {
  const { orderTable, setOrderTable } = useContextContrato();
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      align: "left",
      width: "40px",
    },
    {
      title: "Visualizar",
      align: "center",
      width: "80px",
      minWidth: "80px",
    },
    {
      title: "Proposta",
      align: "center",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Parcelas",
      align: "center",
      width: "110px",
      minWidth: "110px",
      clickOrder: () => {
        setOrderTable(orderTable === "asc" ? "desc" : "asc");
      },
      icon: orderTable === "asc" ? <ArrowUpwardIcon sx={{ fontSize: "12px", ml: "4px" }} /> : <ArrowDownwardIcon sx={{ fontSize: "12px", ml: "4px" }} />,
    },
    {
      title: "Titular / Razão social",
      align: "left",
      minWidth: "180px",
      width: "230px",
    },
    {
      title: "Vidas",
      align: "center",
      width: "90px",
      minWidth: "90px",
    },
    {
      title: "Operadoras / Modalidades",
      align: "left",
      minWidth: "200px",
      width: "200px",
    },



    {
      title: "D. vencimento",
      align: "center",
      width: "100px",
      minWidth: "120px",
    },

    {
      title: "Status Pagamento",
      tooltip: "Status do pagamento",
      align: "center",
      width: "135px",
      minWidth: "135px",
    },
    {
      title: "R$ Mensalidade ",
      tooltip: "Valor Mensalidade",
      align: "left",
      width: "100px",
      minWidth: "130px",
    },
    {
      title: "D. Recebimento",
      tooltip: "Data do recebimento",
      align: "center",
      width: "100px",
      minWidth: "130px",
    },
    {
      title: "P. Corretor ?",
      tooltip: "Pago para o corretor",
      align: "center",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "P. Supervisor ?",
      tooltip: "Pago para o supervisor",
      align: "center",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "P. Gerente ?",
      tooltip: "Pago para o gerente",
      align: "center",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "V. Mens. divergente",
      tooltip: "Valor Mens. Divergente",
      align: "left",
      width: "150px",
      minWidth: "150px",
    },
    {
      title: "R$ Contrato",
      tooltip: "Valor do contrato",
      align: "left",
      width: "100px",
      minWidth: "110px",
    },
    {
      title: "R$ Corretora",
      tooltip: "Valor que a corretora recebe",
      align: "left",
      width: "110px",
      minWidth: "110px",
    },
    {
      title: "R$ Corretor",
      tooltip: "Valor que a corretora paga para o corretor",
      align: "left",
      width: "100px",
      minWidth: "110px",
    },
    {
      title: "R$ Supervisor",
      tooltip: "Valor que a corretora paga para o supervisor",
      align: "left",
      width: "100px",
      minWidth: "120px",
    },
    {
      title: "R$ Gerente",
      tooltip: "Valor que a corretora paga para o gerente",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Lucro parc.",
      tooltip: "Valor que a corretora lucrou",
      align: "left",
      width: "100px",
      minWidth: "100px",

    },
    {
      title: "% Corretora",
      tooltip: "Porcentagem que a corretora recebe",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "% Corretor",
      tooltip: "Porcentagem que a corretora paga para o corretor",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "% supervisor",
      tooltip: "Porcentagem que a corretora paga para o supervisor",
      align: "left",
      width: "100px",
      minWidth: "110px",
    },
    {
      title: "% Gerente",
      tooltip: "Porcentagem que a corretora paga para o gerente",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Corretor",
      align: "left",
      width: "200px",
      minWidth: "120px",
    },
    {
      title: "Supervisor",
      align: "left",
      width: "200px",
      minWidth: "120px",
    },
    {
      title: "Gerente",
      align: "left",
      width: "200px",
      minWidth: "120px",
    },
    {
      title: "T. contrato",
      align: "center",
      minWidth: "110px",
      width: "110px",
      tooltip: "Tipo de contrato",
    },

    {
      title: "Status contrato",
      align: "left",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Obs da parcela",
      align: "left",
      width: "120px",
      minWidth: "120px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
